import gql from "graphql-tag";

export const AssistantBrokers = gql`
  query assistantBrokers($userId: String!,$token:String!,$statuses: [Int]!) {
    AssistantBrokers(userId:$userId,token:$token,statuses: $statuses){
      su_ID,
      su_name,
      su_surname,
      su_email,
      ab_Id,
      status
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/assistant/Broker_Assignment/BrokerAssignment.js